<template>
<div>
    <div ref="dropdownContainer" class="dropdown dropdown-help" :class="{ 'is-active': isDropdownActive }">
        <div class="dropdown-trigger">
        <button
            class="button is-primary"
            aria-haspopup="true"
            aria-controls="dropdown-menu"
            @click="toggleDropdown"
        >
            <span>Page Help</span>
            <span class="icon is-small">
            <i class="mdi mdi-menu-down mdi-24px"></i>
            </span>
        </button>
        </div>
        <div class="dropdown-menu" id="dropdown-menu" role="menu">
            <div class="dropdown-content">
                <a href="#" class="dropdown-item-help" @click="openPageHelp=true,isDropdownActive = false">Page Description</a>
                <div class="dropdown-title-help mt-3">VIDEOS</div>
                <a @click="isDropdownActive = false" v-if="pageHelp == 'results' || pageHelp == 'shortlist'" href="https://www.youtube.com/watch?v=59zP75p2Ojo" target="_blank" class="dropdown-item-help">How to shortlist funds of interest</a>
                <a @click="isDropdownActive = false" v-if="pageHelp == 'results' || pageHelp == 'shortlist'" href="https://www.youtube.com/watch?v=lXoR8RIfDhU" target="_blank" class="dropdown-item-help">Comparing funds to a benchmark</a>
                <a @click="isDropdownActive = false" v-if="pageHelp == 'compare'" href="https://www.youtube.com/watch?v=z9DXTMl0IFo" target="_blank" class="dropdown-item-help">Compare to find the top ranked</a>
                <div class="dropdown-title-help mt-3">FAQS</div>
                <a @click="isDropdownActive = false" v-if="pageHelp == 'results' || pageHelp == 'shortlist'" href="/faq?id=13" class="dropdown-item-help" target="_blank">How can I sort a list of investment funds</a>
                <a @click="isDropdownActive = false" v-if="pageHelp == 'results' || pageHelp == 'shortlist'" href="/faq?id=5" class="dropdown-item-help" target="_blank">Fund filters</a>
                <a @click="isDropdownActive = false" v-if="pageHelp == 'results' || pageHelp == 'shortlist'" href="/faq?id=10" class="dropdown-item-help" target="_blank">Where can I get a detailed view of investment funds</a>
                <a @click="isDropdownActive = false" v-if="pageHelp == 'results' || pageHelp == 'shortlist'" href="/faq?id=11" class="dropdown-item-help" target="_blank">Shortlisting investment funds</a>
                <a @click="isDropdownActive = false" v-if="pageHelp == 'results' || pageHelp == 'shortlist'" href="/faq?id=3" class="dropdown-item-help" target="_blank">How to compare fund performance to a benchmark</a>
                <a @click="isDropdownActive = false" v-if="pageHelp == 'compare'" href="/faq?id=6" class="dropdown-item-help" target="_blank">How to compare funds</a>
            </div>
        </div>
    </div>
    <!-- <h2><a class="is-size-6 has-text-weight-bold has-text-underline is-white-space-nowrap">Page Help</a></h2> -->
    <div :style="{width: width, height: height}" class="model" :class="{'show-modal': imgLoaded}" v-if="openPageHelp">
        <div class="model-head">
            <a class="model-close" v-on:click="openPageHelp=false"><img src="/img/close.png" /></a>
        </div>
        <div class="model-body center">
            <div class="is-flex is-justify-content-center w-100">
                <img @load="onImgLoad" :src="imageDescription" :alt="imageAlt">
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        pageHelp:String,
        width: String,
        height: String,
    },
    computed: {
        imageDescription() {
            switch (this.pageHelp) {
                case 'filters':
                    return '/img/HELP_filters.png';
                case 'referral':
                    return '/img/HELP_referral.png';
                case 'results':
                    return '/img/HELP_results.png';
                case 'detailed':
                    return '/img/HELP_detailedview.png';
                case 'compare':
                    return '/img/HELP_comparison.png';
                case 'shortlist':
                    return '/img/HELP_shortlist.png';
                case 'watchlist':
                    return '/img/HELP_watchlist.png';
                case 'dashboard':
                    return '/img/HELP_dashboard.png';
                default:
                    break;
            }
            return '';
        },
        imageAlt() {
            switch (this.pageHelp) {
                case 'referral':
                    return 'Check on which investment platforms the various share classes of your fund can be bought';
                case 'results':
                    return 'Once your search results are displayed, sort your investment funds and use filters to trim the list of funds to choose from';
                case 'compare':
                    return 'Compare your investment fund to its category peers. Select 1 criteria out of 5 and see your fund rankings plus the top funds ';
                default:
                    break;
            }
            return '';
        }
    },
    data() {
        return {
            openPageHelp: false,
            imgLoaded: false,
            isDropdownActive: false,
        }
    },
    name: 'PageHelp',
     methods: {
         onImgLoad () {
             this.imgLoaded = true
         },
        toggleDropdown() {
            this.isDropdownActive = !this.isDropdownActive;
        },
        closeDropdown(event) {
            if (
                this.$refs.dropdownContainer &&
                !this.$refs.dropdownContainer.contains(event.target)
            ) {
                this.isDropdownActive = false;
            }
        },
     },
     mounted() {
        document.addEventListener("click", this.closeDropdown);
    },
    beforeUnmount() {
        document.removeEventListener("click", this.closeDropdown);
    },
}
</script>

<style scoped>
.dropdown .dropdown-trigger button.button.is-primary {
    background-color: #4173ea;
    color: #fff;
}
.dropdown .dropdown-trigger button.button.is-primary .icon .mdi-24px.mdi:before {
    color: #fff;
}
.dropdown.is-active .dropdown-trigger button.button.is-primary {
    background-color: #fff;
    color: #153647;
}
.dropdown.is-active .dropdown-trigger button.button.is-primary .icon .mdi-24px.mdi:before {
    color: #153647;
}
.dropdown-help .dropdown-item-help {
    font-size: 14px;
    display: block;
    text-align: left;
    font-weight: 400;
    margin-bottom: 5px;
}
.dropdown-help .dropdown-title-help {
    font-size: 20px;
    font-weight: bold;
    text-align: left;
}
.dropdown-help .dropdown-content {
    padding: 20px 10px;
    line-height: 1.2;
    width: 340px;
    background: #fff;
    color: #153647;
}
.model{
    background-color:#FFF;
    position: fixed;
    top:45px;
    max-width: 1000px;
    z-index:300;
    color:#333;
    -webkit-box-shadow: 5px 5px 50px 1px #4F4F4F;
    box-shadow: 5px 5px 50px 1px #4F4F4F;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: 45px auto 0;
    display: none;
    overflow: auto;
    max-height: calc(100vh - 90px);
    height: auto;
}
.show-modal {
    display: block!important;;
}

.model-icon{
    background-color:#ccc;
    padding:10px;
}

.model-head .model-close img{
    height:50px;
    float:right;
}
.model-body{
    padding: 0 25px 25px 25px;
    display: flex;
    justify-content: center;
    width: 100%;
}
.model-body h2{
    font-weight:900;
    margin-bottom:20px;
}

.model-body ul {
    list-style: square;
    padding-left: 15px;
}

.model-body ul li {
    margin-bottom: 15px;
}
</style>